import { journeyAction, } from './base';

import { JourneyActionVoiceSayDigits as JourneyActionVoiceSayDigitsBase, } from 'atlas-shared';

export const JourneyActionVoiceSayDigits = journeyAction({
  ...JourneyActionVoiceSayDigitsBase,
  icon: 'Numbers',
});
